var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.prefix__st0 {\n\t\t\tfill: none;\n\t\t\tstroke: #414141;\n\t\t\tstroke-miterlimit: 10\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M19.3.4c-1.2.1-3.7 2.7-3.7 5.4v5.3c0 .8.4 1.6 1.1 2l-.3 8.8c0 .9.8 1.6 1.7 1.6s1.7-.7 1.7-1.6V.9c0-.5-.5-.5-.5-.5zM4.2 0v6.6c0 1.4 1.2 3 2.5 3.3l-.3 11.8c0 .9.8 1.8 1.7 1.8.9 0 1.7-.9 1.7-1.8L9.5 10c1.3-.3 2.5-1.9 2.5-3.3V0M6.8 0v6M9.5 0v6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverware);
export default __webpack_public_path__ + "static/media/silverware.661e959c44b2cc79f9a05750917814fe.svg";
export { ForwardRef as ReactComponent };